import EntityMapper from './EntityMapper';

import Episode, {EpisodeVisibility} from '../../../domain/entities/Episode';

export interface EpisodeData {
  id: number;
  story_id: number;
  title: string;
  visibility: EpisodeVisibility;
  amount: number | null;
  published: boolean;
  published_updated_at: Date;
  scheduled_delivered_at: Date | null;
  next_scheduled_delivery: boolean;
  number_of_story: number;
  updated_at: string;
  created_at: string;
}

export default class EpisodeMapper
  implements EntityMapper<EpisodeData, Episode>
{
  public map(obj: EpisodeData, headers: Headers | null): Episode {
    return new Episode(
      obj.id,
      obj.story_id,
      obj.title,
      obj.visibility,
      obj.amount,
      obj.published,
      obj.published_updated_at,
      obj.scheduled_delivered_at,
      obj.next_scheduled_delivery,
      obj.number_of_story,
      new Date(obj.updated_at),
      new Date(obj.created_at),
    );
  }
}
